import { createI18n } from 'vue-i18n'
import EN from './en'
import ZH from './zh'
const messages = {
  en: {
    ...EN
  },
  zh: {
    ...ZH
  }
}

const getCurrentLanguage = () => {
  const UAlang = navigator.language // zh-CN
  const langCode = UAlang.indexOf('zh') !== -1 ? 'zh' : 'en'
  localStorage.setItem('lang', 'zh')
  return langCode
}

const i18n = createI18n({
  legacy: false, //  Vue I18n 的 Composition API 版本（Vue 3 兼容）
  globalInjection: true, // i18n 实例将会被注入到每个 Vue 组件中，这样你就可以在组件的模板或 setup 函数中直接使用 $t 来翻译文本
  // locale: getCurrentLanguage() || 'zh',
  locale: 'zh',
  messages: messages
})

export default i18n
